import {DeliveryMethod} from "../interfaces/interfaces";

export const OnSite: DeliveryMethod = {value: 'OnSite', disabled: false, name: 'Sur place', description: 'Vous vous rendez sur place', price: 0 };
export const Standard: DeliveryMethod =  {value: 'Standard', disabled: true, name: 'Standard', description: '4-10 jours ouvrables', price: 7.00 };
export const Express: DeliveryMethod =  {value: 'Express', disabled: true, name: 'Express', description: '2-5 jours ouvrables', price: 16.00  };


